import { DatePipe, SlicePipe, UpperCasePipe } from '@angular/common';
import { Component, effect, ElementRef, inject, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MicaChat_ChatsEntity } from '@modules/mica-chat/entities/chats.mica-chat';
import { MicaChat_MensajesEntity } from '@modules/mica-chat/entities/mensajes.mica-chat';
import { micaChat_getColorRandom } from '@modules/mica-chat/utils/selector-random-color.mica-chat';
import { MicaChatInputMensaje } from '../mica-chat-input-mensaje/mica-chat-input-mensaje';
import { ChatMessageBubbleComponent } from '../chat-message-bubble/chat-message-bubble';
import { MicaChatService } from '@shared/services/mica-chat.service';

@Component({
  selector: 'app-mica-chat-caja-mensajes',
  imports: [SlicePipe, UpperCasePipe, DatePipe, MicaChatInputMensaje, ChatMessageBubbleComponent],
  templateUrl: './mica-chat-caja-mensajes.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-caja-mensajes.css',
})
export class MicaChatCajaMensajes {
	private readonly micaChatService = inject(MicaChatService);
	readonly presenciaChat = this.micaChatService.presenciaChat;

	constructor() {
    effect(() => {
      this.chat();
      this.mensajes().length;
      queueMicrotask(() => this.scrollToBottom());
    });
  }

  chat = input.required<MicaChat_ChatsEntity>();
  mensajes = input.required<MicaChat_MensajesEntity[]>();
  volver = output<void>();
  private readonly mensajesContainer = viewChild<ElementRef<HTMLElement>>('mensajesContainer');

  getColor() {
    return micaChat_getColorRandom(this.chat().nombre_contacto);
  }

  hayCambioDeFecha(mensaje: MicaChat_MensajesEntity) {
    const index = this.mensajes().indexOf(mensaje);
    if (index === 0) return true;
    const mensajeAnterior = this.mensajes()[index - 1];
    const fechaMensaje = new Date(mensaje.fecha);
    const fechaMensajeAnterior = new Date(mensajeAnterior.fecha);
    return (
      fechaMensaje.getDate() !== fechaMensajeAnterior.getDate() ||
      fechaMensaje.getMonth() !== fechaMensajeAnterior.getMonth() ||
      fechaMensaje.getFullYear() !== fechaMensajeAnterior.getFullYear()
    );
  }

  private scrollToBottom() {
    const container = this.mensajesContainer()?.nativeElement;
    if (!container) return;
    container.scrollTop = container.scrollHeight;
  }

  onVolver() {
    this.volver.emit();
  }
}
